/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useSearchParams } from 'react-router-dom';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { GrantOAuth } from '@/pages/GrantOAuth/GrantOAuth';

export function GrantOAuthPage() {
  const { t } = useMimicTranslation('grantOAuth');
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('client_id');
  const clientName = searchParams.get('client_name');
  const scope = searchParams.get('scope');

  // Get the raw query string without parsing/re-encoding
  const rawQuery = window.location.search.substring(1); // Remove leading '?'

  // Remove client_name manually from the raw query string
  const params = rawQuery.split('&').filter((param) => !param.startsWith('client_name='));
  const queryString = params.join('&');

  const authorizeUrl = `${window.mimicConfig.MIMIC_MGMT_PLANE_API}/api/oauth/authorize?${queryString}`;

  if (!clientId || !scope) {
    return (
      <div style={{ padding: '42px', textAlign: 'center' }}>
        <p>{t('invalidRequest')}</p>
      </div>
    );
  }

  return (
    <GrantOAuth
      clientName={clientName || 'Unknown Application'}
      scopes={scope.split(' ')}
      authorizeUrl={authorizeUrl}
      translations={{
        title: t('title'),
        description: t('description'),
        permissionsTitle: t('permissionsTitle'),
        grantButton: t('grantButton'),
        disclaimer: t('disclaimer'),
      }}
    />
  );
}
